
<template>
  <div class="mainTrContainer">
    <div class="gbgTrucksScenarioContainer">
      <div class="trucksScenario">
        <div class="truckList">
          <div class="listHeader">
            <label class="headerLabel">TRUCK LIST</label>
            <div class="inputContainer">
              <input type="text" placeholder="Search Truck..." v-model="searchQ" class="truckInput">
            </div>

          </div>
          <div class="listContainer">
            <div class="listContent">
              <div v-for="item2 in items2" :key="item2.frameNumber" class="listItem"
                v-on:click="goToTruckDetail(item2.frameNumber)">
                <span class="itemText">Truck {{ item2.frameNumber }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="trucksContainer">
          <main class="truckDetailsMain">
            <section class="truckDetailsRight">
              <section class="truckDetailsLeft">
                <div class="truckDetailsProps">
                  <span style="font-size: 1em;"><strong>FRAME NUMBER: </strong>{{ this.truck.frameNumber }}</span>
                  <span style="font-size: 1em;"><strong>CAPACITY: </strong>{{ this.truck.capacity }} / {{
                    this.truck.totalCapacity }}</span>
                  <span style="display: flex; align-items: center; gap:10px; font-size: 1em;"><strong>ON ROUTE: </strong>
                    <img v-if="this.truck.onRoute" src="@/assets/scenarios/garbage/truck/onRoute.png"><img
                      v-if="!this.truck.onRoute" src="@/assets/scenarios/garbage/truck/notOnRoute.png"></span>

                </div>
                <div class="truckDetailsActions">
                  <div class="truckDetailsAction">
                    <button>START ROUTE</button>
                  </div>
                  <div class="truckDetailsAction">
                    <button>SET READY</button>
                  </div>
                  <div class="truckDetailsAction">
                    <button>EMPTY TRUCK</button>
                  </div>
                  <div class="truckDetailsAction">
                    <button>REFILL FUEL</button>
                  </div>
                </div>
                <div class="truckDetailsGbgCls">
                  <p class="gbgClassP">
                    <span class="garbClsSpan"><strong>GARBAGE CLASS:</strong> </span>
                    <img v-bind="truck" v-if="truck.garbageClass === 'organic'" src="@/assets/scenarios/garbage/truck/organic.png"
                      width="40px" height="20px">
                    <img v-bind="truck" v-if="truck.garbageClass === 'plastic'" src="@/assets/scenarios/garbage/truck/plastic.png"
                      width="40px" height="20px">
                    <img v-bind="truck" v-if="truck.garbageClass === 'paper'" src="@/assets/scenarios/garbage/truck/paper.png"
                      width="40px" height="20px">
                  </p>
                </div>
              </section>
              <div id="mapTrucks">
                <l-map :zoom="zoom" :center="pol[0]" @ready="loadRoute()" ref="map">
                  <l-tile-layer :url="url" :attribution="attribution"/>
                  <l-marker v-if="this.truck.location !== undefined"
                    :lat-lng="[parseFloat(this.truck.location.lat), parseFloat(this.truck.location.lng)]"
                    v-bind="truckIcon"
                    :icon="truckIcon">
                    <l-popup>
                      <span>Truck {{ this.truck.frameNumber }}</span>
                    </l-popup>
                  </l-marker>
                  <l-polyline :lat-lngs="troute.polyline" :color="'red'" />

                  <div v-for="ctc in this.troute.containersToCollect" :key="ctc.serialNumber">
                    <l-marker v-if="truck.garbageClass == 'organic'"
                      :lat-lng="[parseFloat(ctc.containerLocation.lat), parseFloat(ctc.containerLocation.lng)]"
                      :icon="iconOrganic">

                    </l-marker>

                    <l-marker v-if="truck.garbageClass == 'paper'"
                      :lat-lng="[parseFloat(ctc.containerLocation.lat), parseFloat(ctc.containerLocation.lng)]"
                      :icon="iconPaper">

                    </l-marker>

                    <l-marker v-if="truck.garbageClass == 'plastic'"
                      :lat-lng="[parseFloat(ctc.containerLocation.lat), parseFloat(ctc.containerLocation.lng)]"
                      :icon="iconPlastic">

                    </l-marker>
                  </div>
                </l-map>
              </div>
            </section>
          </main>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
import trucksGarbageIIOTAPI from '@/services/trucksGarbageIIOTAPI';
import routesGarbageIIOTAPI from '@/services/routesGarbageIIOTAPI';
import L from 'leaflet';
import { LMap, LTileLayer, LPolyline, LPopup, LMarker, LIcon } from 'vue2-leaflet';
import { Icon } from 'leaflet';

export default {
  name: 'TruckDetailViewMeh',
  components: {
    LMap,
    LTileLayer,
    LPolyline,
    LPopup,
    LMarker,
    LIcon,
    
  },
  data() {
    return {
      truck: {},
      map: null,
      layer: null,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 13,
      center: [36.89363, -2.26454],
      items: [],
      items2: [],
      searchQ: '',
      troute: {},
      pol: [[47.334852, -1.509485], [47.342596, -1.328731], [47.241487, -1.190568], [47.234787, -1.358337]],
      iconOrganic: new Icon({
        iconUrl: require('@/assets/scenarios/garbage/container/organic.png'),
        iconSize: [25, 25],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }),
      iconPlastic: new Icon({
        iconUrl: require('@/assets/scenarios/garbage/container/plastic.png'),
        iconSize: [25, 25],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }),
      iconPaper: new Icon({
        iconUrl: require('@/assets/scenarios/garbage/container/paper.png'),
        iconSize: [25, 25],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }),
      truckIcon: new Icon(),
      paperTruckIcon: new Icon({
        iconSize: [25, 25],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
        iconUrl: require('@/assets/scenarios/garbage/truck/paper.png')
      }),
      plasticTruckIcon: new Icon({
        iconSize: [25, 25],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
        iconUrl: require('@/assets/scenarios/garbage/truck/plastic.png')
      }),
      organicTruckIcon: new Icon({
        iconSize: [25, 25],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
        iconUrl: require('@/assets/scenarios/garbage/truck/organic.png')
      }),
    }
  },
  updated() {
    trucksGarbageIIOTAPI.get('/property/fleetDetails').then(async (res) => {
      this.truck = await res.data.filter(item => { return item.frameNumber == this.$route.params.frameNumber })[0];
      this.items = res.data;
      this.items2 = res.data;
      this.center = [parseFloat(this.truck.location.lat), parseFloat(this.truck.location.lng)];
      this.truckIcon.options.iconUrl = require('@/assets/scenarios/garbage/truck/' + this.truck.garbageClass + '.png');
    });
  },
  beforeMount() {
    trucksGarbageIIOTAPI.get('/property/fleetDetails').then(async (res) => {
      this.truck = await res.data.filter(item => { return item.frameNumber == this.$route.params.frameNumber })[0];
      this.items = res.data;
      this.items2 = res.data;
      this.center = [parseFloat(this.truck.location.lat), parseFloat(this.truck.location.lng)];
      if(this.truck.garbageClass === 'organic'){
        this.truckIcon = this.organicTruckIcon;
      } else if(this.truck.garbageClass === 'plastic'){
        this.truckIcon = this.plasticTruckIcon;
      } else if(this.truck.garbageClass === 'paper'){
        this.truckIcon = this.paperTruckIcon;
      }
    });

  
  },
  mounted() {
    this.map = this.$refs.map.mapObject;
    this.loadRoute();
  },
  watch: {
    searchQ: function () {
      console.log(this.searchQ);
      this.items2 = this.items.filter(item => { return item.frameNumber.includes(this.searchQ) });
    },
    truckIcon: function() {
      
    }
  },
  methods: {
    goToTruckDetail(frameNumber) {
      if(frameNumber == this.truck.frameNumber) return;
      this.$router.push('/scenarios/iiot/trucks/' + frameNumber)
    },
    loadRoute() {
      routesGarbageIIOTAPI.get('/631072d253b795505b9ba9cf/property/routeDetails').then((res) => {
        this.troute = res.data;
        var poly = this.troute.polyline;
        var ps = L.polyline(poly, {color: 'blue',
        weight: 5,
        opacity: .7,
        lineJoin: 'round',
        className: 'polylineClass'
        }).addTo(this.map);
        this.map.fitBounds(ps.getBounds());
        
      });

    }
  },
  beforeRouteUpdate(to, from, next) {
    const id = to.params.frameNumber;
    console.log(id);
    trucksGarbageIIOTAPI.get('/property/fleetDetails').then(async (res) => {
      this.truck = await res.data.filter(item => { return item.frameNumber == id })[0];
      this.items = res.data;
      this.items2 = res.data;
      this.center = [parseFloat(this.truck.location.lat), parseFloat(this.truck.location.lng)];
      console.log(this.truck.garbageClass);
      if(this.truck.garbageClass === 'organic'){
        this.truckIcon = this.organicTruckIcon;
      } else if(this.truck.garbageClass === 'plastic'){
        this.truckIcon = this.plasticTruckIcon;
      } else if(this.truck.garbageClass === 'paper'){
        this.truckIcon = this.paperTruckIcon;
      }
      
      console.log(this.truckIcon.options.iconUrl);
      next();
    });
    
    
  }

}
</script>
<style>
 @import "~leaflet/dist/leaflet.css";

.polylineClass {
  z-index: 1000;
}

.mainTrContainer {
  display: grid;
  place-items: center;
  height: 100%;
}

.gbgTrucksScenarioContainer {
  display: grid;
  place-items: center;
  background-color: #F6F6F6;
  border-radius: 12px;
  padding: 0rem 0rem 0rem 0rem;
  margin: 1rem 0;
  border: 1px solid #AAA;
  height: 65vh;
}

.truckDetailsActions {
  margin: 0.8rem;
  display: grid;
  place-items: center;
  grid-template-areas: 'a a'
    'a a';
  gap: 10px;
}

.truckDetailsAction {
  display: grid;
  place-items: center;
  width: 100%;
  font-weight: bold;
  grid-area: 'a';
}

.truckDetailsAction>button {
  width: 100%;
  height: 100%;
  border: none;
  background-color: #DDDFE3;
  border-radius: 16px;
  font-size: 1em;
  font-weight: bold;
  color: #2F2F2F;
  cursor: pointer;
}

.truckDetailsGbgCls {
  position: relative;
}

.gbgClassP {
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
}

.truckDetailsProps {
  color: white;
  margin: 0.8rem;
  margin-bottom: 0;
  display: grid;
  justify-content: space-between;
  padding: 1rem;
}


.trucksContainer {
  background-color: #DDDFE3;
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
}

.onRouteContainer {
  display: flex;
  align-items: center;
}

.onRouteContainer img {
  margin-left: 10px;
}

.garbageClsContainer {
  display: flex;
  align-items: center;
  font-size: xx-small;
  margin-bottom: -30px;
}

.garbageClsContainer img {
  margin: 10px;
}

.trucksScenario {
  display: grid;
  grid-template-columns: 1fr 7fr;
  height: 100%;
  max-width: 1150px;
  border-right: 1px solid #BBB;
}

.truckList {
  background-color: #DDDFE3;
  display: grid;
  grid-template-rows: 15% 85%;
  place-items: center;
  height: 100%;
  width: 100%;
  border-right: 1px solid #BBB;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;

}

.listHeader {
  display: grid;
  place-items: center;
  width: 100%;
  /*height: 100%;*/
  height: 100%;
  background-color: #B0B5BF;
  border-top-left-radius: 10px;
}

.listContent {
  display: grid;
  place-items: center;
  width: 100%;
}

.listContent>div:nth-child(even) {
  background-color: #D9D9D9;
}

.listContent>div:nth-child(odd) {
  background-color: #C6C6C6;
}

.listContent>div {
  padding: 0.4rem;
  cursor: pointer;
}

.listItem {
  width: 100%;
}

.itemText {
  font-weight: 500;
  font-size: 1.2rem;
  color: #63635B;
  margin: 1rem;
}

.inputContainer {
  background-color: white;
  border-radius: 24px;
  margin-bottom: 10px;
  text-align: start;
  display: grid;
  place-items: center;
  padding-left: 10px;
  height: 60%;
  width: 80%;
}

.truckInput {
  font-weight: 500;
}

.headerLabel {
  font-weight: 700;
  font-size: 1.2rem;
  color: #FFF;
}

.listContainer {
  width: 100%;
  height: 100%;
}

#mapTrucks {
  position: inherit;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: all;
  z-index: 0;
}

.mapWrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 23, 0);
  pointer-events: none;
}

.truckDetailsLeft {
  display: grid;
  /*width: 350px;
    height: 350px;*/
  width: 40%;
  height: 40%;
  min-width: 275px;
  min-height: 275px;
  top: 0;
  left: 0;
  position: relative;
  padding: 10px;
  vertical-align: middle;
  background-color: #25262D;
  grid-template-rows: 1fr 1fr 1fr;
  z-index: 1;
  margin-top: -20px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.truckDetailsRight {
  display: grid;
  position: relative;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  background-color: #f6f6f6;

}

.truckDetailsMain {
  width: 100%;
  height: 100%;
  display: grid;
  /*grid-template-columns: 1fr 1fr;*/
  place-items: center;
  color: white;
  min-height: 100px;
}

.garbClsSpan {
  margin-right: 1rem;

}
</style>